/**
 * Display-side title casing (QA #88): "zoho admin communication" → "Zoho Admin Communication".
 * Words that already carry an uppercase letter are left alone so "iOS", "QA", "SDE-II" and
 * "McKinsey" survive. Display-only — stored titles are never mutated, so historical rows are
 * covered without a migration.
 */
export function displayTitle(raw: string): string {
  return raw
    .trim()
    .replace(/\s+/g, " ")
    .split(" ")
    .map((w) => (/[A-Z]/.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(" ");
}
